import {
  FDBox, FDPaper, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';

const BlockItem = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <FDPaper
      appearance={'flat'}
      color={resource.attr('color')}
      key={resource.id()}
      width={'525px'}
      {...dataAttrs('planner-guide-block-item')}
    >
      <FDBox paddingX={3} paddingY={5} height={'100%'}>
        <FDStack direction={'column'} spacing={3} justifyContent={'space-between'} height={'100%'}>
          <FDStack direction={'column'}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'description'} />
          </FDStack>
          <MetaControlField attr={'examples'} />
        </FDStack>
      </FDBox>
    </FDPaper>
  );
};

export default BlockItem;
